export default import.meta.ROLLDOWN_FILE_URL_JmIVdBxiferYbGHZxrt31Q